import { useEffect, useRef, useState } from 'react';
import { BUILD_PHASE } from "../../../utils/sparkflow-constants";
const TICK_MS = 2000;
const FAST_INCREMENT = 8;
const SLOW_INCREMENT = 2;
const FAST_PROGRESS_THRESHOLD = 88;
const PROGRESS_CAP = 96;
export function useSimulatedProgress(buildPhase, hasError, resetKey) {
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef(null);
    const getIncrement = (prev) => prev < FAST_PROGRESS_THRESHOLD ? FAST_INCREMENT : SLOW_INCREMENT;
    const clearTimer = () => {
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    const startInterval = () => {
        intervalRef.current = setInterval(() => {
            setProgress(prev => Math.min(prev + getIncrement(prev), PROGRESS_CAP));
        }, TICK_MS);
    };
    useEffect(() => {
        setProgress(0);
    }, [resetKey]);
    useEffect(() => {
        if (buildPhase === BUILD_PHASE.COMPLETED) {
            clearTimer();
            setProgress(100);
        }
        else if (hasError) {
            clearTimer();
        }
        else if (!intervalRef.current) {
            startInterval();
        }
        return () => clearTimer();
    }, [buildPhase, hasError]);
    return progress;
}
//# sourceMappingURL=use-simulated-progress.js.map